/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const FEATURED_EXTENDED = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    article_overview: PropTypes.string,
    article_title: PropTypes.string,
    content_type: PropTypes.string,
    field_feature_article: PropTypes.string,
    field_promotional_image: PropTypes.string,
    hero_image_alt_text: PropTypes.string,
    time_changed: PropTypes.string,
    time_created: PropTypes.string,
    contentType: PropTypes.string,
    url: PropTypes.string,
});

export const BREADCRUMB = PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
});

// TODO: This needs flushing out and probably needs to live in the search service
export const UI_FILTERS = PropTypes.shape({
    accommodations: PropTypes.object,
    activities: PropTypes.object,
    campsiteAmenities: PropTypes.object,
    campsiteElectricityHookup: PropTypes.object,
    campsiteEquipment: PropTypes.object,
    campsiteTypes: PropTypes.object,
    campsiteUseTypes: PropTypes.object,
    campsiteVehicleLength: PropTypes.object,
    hasFilters: PropTypes.bool,
    includeUnavailable: PropTypes.bool,
    inventoryTypes: PropTypes.object, // unknown object contents
    lastAppliedFilter: PropTypes.any, // unknown
    occupants: PropTypes.object,
    permitTypes: PropTypes.object,
    reservable: PropTypes.object,
    tourAccessible: PropTypes.object,
    tourDifficulty: PropTypes.object,
    tourDuration: PropTypes.object,
    tourPrice: PropTypes.object,
    tourTime: PropTypes.object,
    tourTypes: PropTypes.object,
});

// TODO: This probably needs to live in the search service
export const SEARCH = PropTypes.shape({
    aggregations: PropTypes.array,
    checkin_time: PropTypes.string,
    checkout_time: PropTypes.string,
    filters: PropTypes.array,
    filtersVisible: PropTypes.bool,
    headerTextQuery: PropTypes.string,
    highlighted_item: PropTypes.number,
    inventoryTypeFiltersVisible: PropTypes.bool,
    lat: PropTypes.number,
    lng: PropTypes.number,
    map_center_lat: PropTypes.number,
    map_center_lng: PropTypes.number,
    placeid: PropTypes.string,
    placename: PropTypes.string,
    radius: PropTypes.number,
    showSearchInput: PropTypes.bool,
    size: PropTypes.number,
    sort: PropTypes.string,
    start: PropTypes.number,
    type: PropTypes.string,
    uiFilters: UI_FILTERS,
    what: PropTypes.string,
    where: PropTypes.string,
});

export const VALIDATION_ACTIONS = PropTypes.objectOf(PropTypes.func);

export const VALIDATIONS = PropTypes.objectOf(PropTypes.objectOf(PropTypes.any));

export const FORM_VALIDATION_ERROR_ITEM = PropTypes.shape({
    errorText: PropTypes.string,
    inputId: PropTypes.string.isRequired,
});

export const FORM_VALIDATION_ERRORS = PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.arrayOf(FORM_VALIDATION_ERROR_ITEM)),
    PropTypes.arrayOf(FORM_VALIDATION_ERROR_ITEM),
]);
